import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Point, Six as GoAvatar } from 'assets'
import { Img } from 'styles/GlobalStyle'
import { PerformAssessmentContext } from './PerformAssessmentContext'
import { FabButtonStyles, Step3Styles } from './Style'
import { AnimatePresence } from "motion/react"
import { ReactComponent as MicIcon } from 'assets/icons/Mic.svg';
import { IconButton, SvgIcon } from '@mui/material'
import { Pause, PlayArrow } from '@mui/icons-material'
import { categories, visibleTypes } from 'keys'
import { CheckPermissions, NextButton } from '.'
import { ReactComponent as GoIcon } from 'assets/icons/FatGo.svg';
import { screen_3_biblical_text_female, screen_3_biblical_text_male, screen_3_narrative_text_click_and_start_female, screen_3_narrative_text_click_and_start_male, screen_3_word_list_click_and_start_female, screen_3_word_list_click_and_start_male } from 'introductions'
import { _screen_3_word_list_no_nikud_click_and_start_female, _screen_3_narrative_text_click_and_start_male, _screen_3_narrative_text_click_and_start_female, _screen_3_word_list_no_nikud_click_and_start_male } from 'introductions/highGrades'
import * as motion from "motion/react-client"
import ReactPlayer from 'react-player'
import TooltipMessage from './Tooltip'
import tooltips from './utils/tooltips'

const Step3 = () => {
    const { isHighGrade, isMaleGender, micDisabled, assessmentDef, setMicDisabled, setReadAloudFlag, setCurrentStep } = useContext(PerformAssessmentContext)
    const [cartoonSpeaking, setCartoonSpeaking] = useState(true)
    const [shouldAnimate, setShouldAnimate] = useState(false);
    const [disabledNext, setDisabledNext] = useState(true)

    // הגדרה כללית פר סוג תצוגה
    const assessmentDefItem = {
        [visibleTypes.WORD_GROUP]: {
            record:
                isHighGrade ?
                    (isMaleGender ? _screen_3_word_list_no_nikud_click_and_start_male : _screen_3_word_list_no_nikud_click_and_start_female) :
                    (isMaleGender ? screen_3_word_list_click_and_start_male : screen_3_word_list_click_and_start_female),
            assessmentId: 40,
            tooltip: isMaleGender ? tooltips.start_perform_m : tooltips.start_perform_f
        },
        [visibleTypes.PARAGRAPH]: {
            record:
                isHighGrade ?
                    (isMaleGender ? _screen_3_narrative_text_click_and_start_male : _screen_3_narrative_text_click_and_start_female) :
                    (isMaleGender ? screen_3_narrative_text_click_and_start_male : screen_3_narrative_text_click_and_start_female),
            assessmentId: null,
            tooltip: isMaleGender ? tooltips.check_mic_book_m : tooltips.check_mic_book_f
        },
        [visibleTypes.MULTIPLE_CHOICE]: {
            record: null,
            assessmentId: null,
            tooltip: isMaleGender ? tooltips.start_perform_m : tooltips.start_perform_f
        }
    }

    // אם רוצים הגדרות מיוחדות פר קטגוריה
    const assessmentDefItemByCategory = {
        ["default"]: {
            record: isMaleGender ? screen_3_biblical_text_male : screen_3_biblical_text_female,
            assessmentId: null
        },
        [categories.BIBLICAL_TEXT]: {
            record: isMaleGender ? screen_3_biblical_text_male : screen_3_biblical_text_female,
            assessmentId: null
        }
    }

    const item = assessmentDefItemByCategory[assessmentDef.category_name] || assessmentDefItem?.[assessmentDef?.visible_type] || assessmentDefItemByCategory.default

    const getMicPermission = useCallback(() => {
        navigator.getUserMedia = (navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia);
        navigator.getUserMedia({ audio: true },
            () => {
                return true
            },
            () => {
                setMicDisabled(true)
                return false
            }
        );
    }, [])

    const goNextStep = useCallback(async () => {
        navigator.getUserMedia = (
            navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia
        )
        navigator.getUserMedia({ audio: true },
            () => {
                navigator.mediaDevices.getUserMedia({ audio: true }).then(() => {
                    setReadAloudFlag(true)
                    setShouldAnimate(true)
                    setCartoonSpeaking(false)
                    //של הצעד הבא, כדי למנוע אפשרות של לחיצה כפולה שמעבירה שני צעדים index - חשוב לשים את המספר 
                    setCurrentStep(4)
                }, () => setMicDisabled(true))
            },
            () => setMicDisabled(true)
        );
    }, [])

    const handleCartoonSpeaking = useCallback(() => {
        setCartoonSpeaking(cartoonSpeaking => !cartoonSpeaking)
    }, [])

    useEffect(() => {
        setDisabledNext(false)
    }, [])

    return (
        <Step3Styles>
            {micDisabled ?
                <CheckPermissions checkPermissions={getMicPermission} /> :
                <React.Fragment>
                    <div className='wrap-content'>
                        {isHighGrade ?
                            <TooltipMessage
                                tooltip={assessmentDefItem?.[assessmentDef?.visible_type]?.tooltip} />
                            :
                            !shouldAnimate ? (
                                <div className='wrap-cartoon-img'>
                                    <motion.div
                                        initial={{ opacity: 0 }} // מתחיל מחוץ למסך משמאל
                                        animate={{ y: 1, x: 1, opacity: 1 }} // נכנס למקום שלו
                                        exit={{ opacity: 0 }} // יוצא מהמסך משמאל
                                        transition={{ duration: 0.7 }}
                                        className='cartoon-img'
                                        key="cartoon-img"
                                    >
                                        <Img src={cartoonSpeaking ? Point : Point} />
                                        <div className='play-pause-cartoon'>
                                            <IconButton onClick={handleCartoonSpeaking}>
                                                {cartoonSpeaking ? <Pause color="thirdly" /> : <PlayArrow color="thirdly" />}
                                            </IconButton>
                                        </div>
                                    </motion.div>
                                </div>
                            ) : null}
                        {!shouldAnimate ? (
                            <motion.div
                                initial={{ opacity: 0.4 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0.4 }}
                                transition={{ duration: 0.7 }}
                                className='mic-img'
                                key="mic-img"
                            >
                                <div className='wrap-fab-button'>
                                    <NextButton
                                        action={goNextStep}
                                        disabled={disabledNext} />

                                    {/* <FabButtonStyles fill="transparent" stroke="white">
                                            <IconButton
                                                onClick={goNextStep}
                                                disabled={disabledNext}>
                                                <SvgIcon fontSize="small" component={GoIcon} inheritViewBox />
                                                {/* <SvgIcon fontSize='small' component={MicIcon} inheritViewBox /> */}
                                    {/* </IconButton>
                                        </FabButtonStyles> */}
                                </div>
                            </motion.div>
                        ) : null}
                    </div>
                    <ReactPlayer
                        playing={cartoonSpeaking}
                        url={item?.record}
                        width='0px' height='0px'
                        onEnded={() => setCartoonSpeaking(false)}
                    />
                </React.Fragment>}
        </Step3Styles>
    )
}

export default Step3